import { useLocation } from "react-router";
import useFetch from "../../../hooks/useFetch";
import { Link } from "react-router-dom";
import GriSupplierReportDetailsData from "./GriSupplierReportDetailsData";

export default function GriSupplierReportDetails() {

    const { state } = useLocation();

    const { data, isLoading } = useFetch(`gri/getAllGRIDetails?id=${state}`);

    if (isLoading) {
        return (
            <>
                <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                        <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                    </div>
                </main>
            </>
        )
    }

    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">
                        <Link to="/grisupplierreport" >
                            <i className="fa-solid fa-arrow-left"></i>
                        </Link>{' '}
                        Gri Supplier Report Details
                    </h1>
                </div>
                <div>
                    <h4>
                        <small>Seller: {data.seller}</small>
                    </h4>
                    <h4>
                        <small>Year: {data.year}</small>
                    </h4>
                </div>
                <div class="table-responsive">
                    <table className="table table-bordered table-hover table-sm">
                        <thead>
                            <tr>
                                <th>GRI STANDARD OTHER SOURCE</th>
                                <th>DISCLOSURE</th>
                                <th>LOCATION</th>
                                <th>REQUIREMENT(S) OMITTED</th>
                                <th>REASON</th>
                                <th>EXPLANATION</th>
                                <th>GRI SECTOR STANDARD REF. NO.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <GriSupplierReportDetailsData data={data.data} id={data.id} />
                        </tbody>
                    </table>
                </div>
            </main>
        </>
    )
}